document.addEventListener('DOMContentLoaded', () => {
  const copyBtns = document.querySelectorAll(".code-value-btn");
  copyBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      var code = btn.previousElementSibling.textContent;
      const copied = btn.nextElementSibling;
      navigator.clipboard.writeText(code);
      btn.classList.add("active");

      setTimeout(function () {
        btn.classList.remove("active");
      }, 3000);
    });
  });

  const proCopyBtns = document.querySelectorAll('.bfcm-product-code')

  proCopyBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      var code = btn.querySelector('.code-value').textContent
      const btnText =  btn.querySelector('.code-copy-btn')
      const copied = btn.nextElementSibling;
      navigator.clipboard.writeText(code);
      btnText.textContent = 'Copied'

      setTimeout(function () {
        btnText.textContent = 'Copy'
      }, 3000);
    });
  });


  const comboItem = document.querySelector('#keyboard-lists')
  comboItem.classList.add('active')



  // klaviyo 邮箱弹窗
  const windowBtns = $('.close-window-btn')
  windowBtns.click(function() {
    const $this = $(this)
    $this.parents('.klaviyo-window-box').removeClass('active')
  })


  const notifyBtns = $('.notify-me-btn')
  notifyBtns.click(function() {
    const $this = $(this)
    const parent = $this.parents('.section-notify')
    parent.find('.klaviyo-window-box').addClass('active')
  })

});